import React from 'react';
import ContentLoader from 'react-content-loader';

const confirmOfferSkel = <ContentLoader speed={1} viewBox="0 0 300 300" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* titre */}
    <rect x="16" y="10" width="260" height="18" />
    <rect x="20" y="35" width="250" height="18" />
    <rect x="65" y="60" width="150" height="18" />
    {/* panier */}
    <rect x="16" y="95" width="60" height="18" />
    {/* cadre */}
    <rect x="16" y="120" width="255" height="3" />
    <rect x="16" y="120" rx="0" ry="0" width="3" height="100" />
    <rect x="270" y="120" rx="0" ry="0" width="3" height="100" />
    <rect x="16" y="220" width="257" height="3" />

    {/* offre */}
    <circle cx="55" cy="160" r="25" />
    <rect x="90" y="150" width="120" height="15" />
    <rect x="40" y="200" width="200" height="10" />
    {/* bouton */}
    <rect x="16" y="250" rx="0" ry="0" width="255" height="30" />
</ContentLoader>
const identitySkel = <ContentLoader speed={1} viewBox="0 0 300 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* civilite */}
    <rect x="16" y="0" width="60" height="13" />
    <rect x="16" y="18" width="130" height="23" />
    <rect x="150" y="18" width="130" height="23" />
    {/* nom */}
    <rect x="16" y="50" width="60" height="13" />
    <rect x="16" y="68" width="263" height="23" />
    {/* prenom */}
    <rect x="16" y="100" width="60" height="13" />
    <rect x="16" y="118" width="263" height="23" />
    {/* date naissance */}
    <rect x="16" y="150" width="60" height="13" />
    <rect x="16" y="168" width="130" height="23" />
    {/* pays */}
    <rect x="16" y="200" width="60" height="13" />
    <rect x="16" y="218" width="263" height="23" />
    {/* ville */}
    <rect x="16" y="250" width="60" height="13" />
    <rect x="16" y="268" width="263" height="23" />
    {/* email */}
    <rect x="16" y="300" width="60" height="13" />
    <rect x="16" y="318" width="263" height="23" />
    {/* portable */}
    <rect x="16" y="350" width="60" height="13" />
    <rect x="16" y="368" width="130" height="23" />
    {/* fixe */}
    <rect x="16" y="400" width="60" height="13" />
    <rect x="16" y="418" width="130" height="23" />
    {/* bouton */}
    <rect x="16" y="450" rx="0" ry="0" width="30" height="30" />
    <rect x="200" y="450" rx="0" ry="0" width="80" height="30" />

</ContentLoader>
const howToJoinSkel = <ContentLoader speed={1} viewBox="0 0 300 320" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* adresse */}
    <rect x="16" y="0" width="60" height="13" />
    <rect x="16" y="18" width="100" height="23" />
    <rect x="140" y="0" width="60" height="13" />
    <rect x="140" y="18" width="140" height="23" />
    {/* complement adresse */}
    <rect x="16" y="50" width="140" height="13" />
    <rect x="16" y="68" width="263" height="23" />
    {/* code postale */}
    <rect x="16" y="100" width="50" height="13" />
    <rect x="16" y="118" width="80" height="23" />
    <rect x="120" y="100" width="50" height="13" />
    <rect x="120" y="118" width="160" height="23" />
    {/* pays */}
    <rect x="16" y="150" width="60" height="13" />
    <rect x="16" y="168" width="263" height="23" />
    {/* info Box */}
    <rect x="16" y="210" width="263" height="40" />
    {/* bouton */}
    <rect x="16" y="270" rx="0" ry="0" width="30" height="30" />
    <rect x="200" y="270" rx="0" ry="0" width="80" height="30" />

</ContentLoader>
const bankAccountInfoSkel = <ContentLoader speed={1} viewBox="0 0 300 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* nom compte */}
    <rect x="16" y="0" width="120" height="13" />
    <rect x="16" y="18" width="263" height="25" />
    {/* Iban */}
    <rect x="16" y="50" width="80" height="13" />
    <rect x="16" y="68" width="263" height="25" />
    {/* Bic */}
    <rect x="16" y="100" width="80" height="13" />
    <rect x="16" y="118" width="263" height="25" />
    {/* bouton */}
    <rect x="16" y="160" rx="0" ry="0" width="30" height="30" />
    <rect x="200" y="160" rx="0" ry="0" width="80" height="30" />

</ContentLoader>
const summarySkel = <ContentLoader speed={1} viewBox="0 0 300 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* info perso */}
    {/* cadre */}
    <rect x="26" y="40" width="130" height="13" />
    <rect x="26" y="58" width="242" height="3" />
    <rect x="26" y="58" width="3" height="90" />
    <rect x="265" y="58" width="3" height="90" />
    <rect x="26" y="145" width="242" height="3" />
    {/* data */}
    <rect x="245" y="70" width="10" height="10" />
    <rect x="40" y="70" width="150" height="10" />
    <rect x="40" y="85" width="120" height="10" />
    <rect x="40" y="100" width="90" height="10" />
    <rect x="40" y="115" width="80" height="10" />
    <rect x="40" y="130" width="80" height="10" />
    {/* adresse */}
    <rect x="26" y="160" width="130" height="13" />
    {/* cadre */}
    <rect x="26" y="178" width="242" height="3" />
    <rect x="26" y="178" width="3" height="80" />
    <rect x="265" y="178" width="3" height="80" />
    <rect x="26" y="255" width="242" height="3" />
    {/* data */}
    <rect x="245" y="190" width="10" height="10" />
    <rect x="40" y="190" width="180" height="10" />
    <rect x="40" y="205" width="170" height="10" />
    <rect x="40" y="220" width="120" height="10" />
    <rect x="40" y="235" width="60" height="10" />
    {/* cordonnées bancaires */}
    <rect x="26" y="270" width="130" height="13" />
    {/* cadre */}
    <rect x="26" y="288" width="242" height="3" />
    <rect x="26" y="288" width="3" height="35" />
    <rect x="265" y="288" width="3" height="35" />
    <rect x="26" y="320" width="242" height="3" />
    {/* info */}
    <rect x="245" y="300" width="10" height="10" />
    <rect x="40" y="300" width="180" height="10" />
    {/* Info Box */}
    <rect x="26" y="340" width="242" height="35" />
    {/* bouton */}
    <rect x="16" y="390" rx="0" ry="0" width="30" height="30" />
    <rect x="200" y="390" rx="0" ry="0" width="80" height="30" />

</ContentLoader>
const signatureSkel = <ContentLoader speed={1} viewBox="0 0 300 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* 1 point */}
    <rect x="26" y="42" width="8" height="8" />
    <rect x="40" y="40" width="200" height="13" />
    <rect x="40" y="55" width="100" height="13" />
    {/* 2 point */}
    <rect x="26" y="78" width="8" height="8" />
    <rect x="40" y="75" width="200" height="13" />
    <rect x="40" y="90" width="100" height="13" />
    {/* 3 point */}
    <rect x="26" y="112" width="8" height="8" />
    <rect x="40" y="110" width="200" height="13" />
    <rect x="40" y="125" width="100" height="13" />

    <rect x="26" y="150" width="230" height="200" />

</ContentLoader>
const cancellationSkle = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <circle cx="190" cy="52" r="40" />

    <rect x="66" y="121" rx="0" ry="0" width="250" height="12" />
    <rect x="126" y="145" rx="0" ry="0" width="130" height="12" />

    <rect x="26" y="181" rx="0" ry="0" width="325" height="8" />
    <rect x="126" y="201" rx="0" ry="0" width="100" height="8" />
</ContentLoader>
const confirmationSkle = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <circle cx="190" cy="52" r="40" />

    <rect x="86" y="121" rx="0" ry="0" width="200" height="12" />
    <rect x="136" y="145" rx="0" ry="0" width="110" height="12" />

    <rect x="96" y="181" rx="0" ry="0" width="180" height="8" />
    <rect x="96" y="201" rx="0" ry="0" width="180" height="8" />

    <rect x="86" y="241" rx="0" ry="0" width="210" height="8" />
    <rect x="160" y="281" rx="0" ry="0" width="50" height="8" />
</ContentLoader>
const enterpriseIdentitySkel = <ContentLoader speed={1} viewBox="0 0 300 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* sociale */}
    <rect x="16" y="20" width="120" height="13" />
    <rect x="16" y="38" width="263" height="25" />
    {/* rep légale */}
    <rect x="16" y="70" width="80" height="13" />
    <rect x="16" y="88" width="263" height="25" />
    {/* titre rep légal */}
    <rect x="16" y="120" width="80" height="13" />
    <rect x="16" y="138" width="263" height="25" />
    {/* siret */}
    <rect x="16" y="170" width="80" height="13" />
    <rect x="16" y="188" width="263" height="25" />
    {/* bouton */}
    <rect x="16" y="220" rx="0" ry="0" width="30" height="30" />
    <rect x="200" y="220" rx="0" ry="0" width="80" height="30" />
</ContentLoader>
const tooEarlySkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="35" y="32" rx="0" ry="0" width="290" height="12" />
    <rect x="85" y="56" rx="0" ry="0" width="160" height="12" />

    <circle cx="190" cy="158" r="80" />
</ContentLoader>
const tooLateSkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="100" y="32" rx="0" ry="0" width="200" height="35" />
    <rect x="85" y="76" rx="0" ry="0" width="230" height="12" />
</ContentLoader>
export const associativeMobileSkelMap = new Map<string, any>([
    ['confirmOfferStep', confirmOfferSkel],
    ['recommendedOfferStep', confirmOfferSkel],
    ['enterpriseIdentityStep', enterpriseIdentitySkel],
    ['identityStep', identitySkel],
    ['howToJoinStep', howToJoinSkel],
    ['bankAccountInfoStep', bankAccountInfoSkel],
    ['summaryStep', summarySkel],
    ['signatureStep', signatureSkel],
    ['confirmationStep', confirmationSkle],
    ['confirmationBarcodeStep', confirmationSkle],
    ['cancellationStep', cancellationSkle],
    ['tooLateStep', tooLateSkel],
    ['tooEarlyStep', tooEarlySkel],
    ['customerInformationStep', identitySkel],
    ['insuredElementStep', identitySkel],
    ['paymentStep', confirmationSkle],
    ['paymentConfirmationStep', confirmationSkle],
    ['paymentFailureStep', confirmationSkle]
]);
